import api from "./config";
import { API_ENDPOINTS } from "../../utils/constants";

const chatApi = {
  CreateChat: async (data) => {
    var response = await api.post(API_ENDPOINTS.CREATE_CHAT, data);
    return response.data;
  },
  GetChat: async (data) => {
    var response = await api.post(API_ENDPOINTS.GET_CHAT, data);
    return response.data;
  },
  UpdateChat: async () => {
    var response = await api.put(API_ENDPOINTS.UPDATE_CHAT);
    return response.data;
  },
};

export default chatApi;
